import { swarmRequest } from '@common/helpers/util/requestMiddleware';

class WithdrawalCommands {
  static getBetshopList() {
    return swarmRequest({}, 'get_bet_shops');
  }

  static getClientBalance() {
    return swarmRequest({ product: 'Sport' }, 'get_client_withdrawable_balance');
  }

  static cashWithdrawalRequest(amount, officeId) {
    return swarmRequest(
      {
        amount,
        service: 353,
        payee: { forProduct: 'sport', isAmountHidden: false, office_id: officeId },
      },
      'withdraw_v2',
    );
  }

  static getWithdrawalHistory(start, end) {
    return swarmRequest({ where: { type: 1, from_date: start, to_date: end } }, 'balance_history_v2');
  }
}
export default WithdrawalCommands;
